import { INSTANCE_NAMES, getInstance } from '@retail/single-instance-cache';

import { UserConfigurationCollection } from './userConfigurationCollection';

export function getUserConfigurationCollection() {
    return getInstance(
        INSTANCE_NAMES.USER_CONFIGURATION_COLLECTION,
        new UserConfigurationCollection(),
    );
}
